module.exports = __webpack_public_path__ + "img/phone.342e2153.jpg";